export const MatchStatus = {
  NotReady: "NOTREADY",
  Ready: "READY",
  InProgress: "INPROGRESS",
  Completed: "COMPLETED",
  Unknown: "UNKNOWN"
}



// WEBPACK FOOTER //
// ./src/js/models.js